import { CurityCredentials } from '../../../utils/auth/types';

export type Credentials = {
  idToken?: string;
  tokenType: string;
  accessToken: string;
  refreshToken: string;
  scope: string;
  claims: string;
  expiresAt: Date;
};

export type SerializedCredentials = {
  idToken?: string;
  tokenType: string;
  accessToken: string;
  refreshToken: string;
  scope: string;
  claims: string;
  expiresAt: string;
};

export function deserializeCredentials(
  serialized: SerializedCredentials
): Credentials {
  return {
    idToken: serialized.idToken,
    tokenType: serialized.tokenType,
    accessToken: serialized.accessToken,
    refreshToken: serialized.refreshToken,
    scope: serialized.scope,
    claims: serialized.claims,
    expiresAt: new Date(serialized.expiresAt),
  };
}

export function transformCredentials(
  credentials: CurityCredentials
): Credentials {
  return {
    idToken: credentials.id_token,
    tokenType: credentials.token_type,
    accessToken: credentials.access_token,
    refreshToken: credentials.refresh_token,
    scope: credentials.scope,
    claims: credentials.claims,
    expiresAt: new Date(Date.now() + credentials.expires_in * 1000),
  };
}

const EXPIRY_BUFFER_MS = 60_000; // treat token as expired 60 s early to cover clock skew

export function isCredentialsExpired(credentials: Credentials): boolean {
  return credentials.expiresAt.getTime() - Date.now() < EXPIRY_BUFFER_MS;
}
